import { Component } from '@angular/core';
import {HostListener} from '@angular/core';
import { TextService } from './services/text-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'chrismiess';

  constructor(public textDefinitions : TextService)
  {
    textDefinitions.load();
  }
}
